// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"318":"7c9efb3594d84b96","697":"335a7dea212ace55"}[chunkId] + ".js";
};